import type { ClientMessage } from '~/composables/update'

const CHECK_UPDATE_INTERVAL = 2 * 60 * 1000

export function useUpdate() {
  let inter: NodeJS.Timeout
  const nowTime = ref(Date.now())
  let needReload = false
  let timer: NodeJS.Timeout

  const runtimeConfig = useRuntimeConfig()
  const route = useRoute()

  const info = ref<{ title: string; description: string }>()

  const message = useUpdateMessage()
  const showUpdateMessages = useShowUpdateMessage()
  const showUpdateMessagesTip = useShowUpdateMessageTip()

  async function checkUpdate() {
    const data = await $fetch(
      runtimeConfig.public.updateMessageJson + '?v=' + Date.now()
    )
    message.value = data as ClientMessage
  }

  const initUpdateMessage = () => {
    if (timer) {
      clearInterval(timer)
    }
    timer = setInterval(() => {
      nowTime.value = Date.now()
      if (!message.value) {
        showUpdateMessages.value = false
        showUpdateMessagesTip.value = false
      } else {
        const {
          is_stop,
          stop_service_timestamp,
          start_service_timestamp,
          is_send_stop_message,
          show_notice_timestamp,
        } = message.value
        showUpdateMessages.value =
          is_stop &&
          stop_service_timestamp * 1000 <= nowTime.value &&
          start_service_timestamp * 1000 >= nowTime.value

        if (route.query.noStop) {
          sessionSetItem('noStop', 1)
        }

        if (route.query.noStop || sessionGetItem('noStop')) {
          showUpdateMessages.value = false
        }

        showUpdateMessagesTip.value =
          is_stop &&
          is_send_stop_message &&
          show_notice_timestamp * 1000 <= nowTime.value &&
          start_service_timestamp * 1000 >= nowTime.value
      }

      if (showUpdateMessages.value) {
        needReload = true
      }
      if (needReload && !showUpdateMessages.value) {
        needReload = false
        window.location.reload()
      }
    }, 1000)
  }

  onMounted(() => {
    inter = setInterval(checkUpdate, CHECK_UPDATE_INTERVAL)
    checkUpdate()
    initUpdateMessage()
  })

  onUnmounted(() => {
    clearInterval(inter)
    if (timer) {
      clearInterval(timer)
    }
  })

  return { info }
}
